import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import DatePicker from "react-datepicker";

const VerifyReconciledPayment = ({ isShown, hide, close, campId, pDate, pAmount, transactionProof }) => {
  //Set initial state
  const [campaignId, handleCampaignId] = useState(campId);
  const [paymentDate, handlePaymentDate] = useState(pDate);
  const [paymentAmount, handlePaymentAmount] = useState(pAmount);
  const [paymentTransactionProof, handlePaymentTransactionProof] = useState(transactionProof);
  const [filteredPayments, handleFilteredPayments] = useState([]);
  const [selectedPayment, handleSelectedPayment] = useState(undefined);
  
  useEffect(() => {
    if (isShown) {
      handleCampaignId(campId);
      handlePaymentDate(pDate);
      handlePaymentAmount(pAmount);
      handlePaymentTransactionProof(transactionProof);

      getFilteredPayments();
    }
  }, [pDate]);
  
  const closePopup = () => {
    hide();
  };
  
  const getFilteredPayments = async () => {
    let offlinePaymentRecord = await Axios.post(`${endPoints.getNonLinkedPaymentsBasedOnDate}`, {
      params: {
        date: pDate,
        amount: pAmount,
        campaign: campId
      }
    });
    
    if(offlinePaymentRecord.data && offlinePaymentRecord.data.message && offlinePaymentRecord.data.message == 'Payments Found'){
      handleFilteredPayments(offlinePaymentRecord.data.data.matchedPayments);
    }else{
      handleFilteredPayments(offlinePaymentRecord.data.data);
    }
  }

  const submitLinkedPayment = async (e) => {
    e.preventDefault();

    let offlinePaymentRecord = await Axios.post(endPoints.linkFailedCampaignToPayments, {
      campaign: (campaignId).toString(),
      paymentId: (selectedPayment).toString()
    });

    window.location.href = './campaign';
    hide();
  }

  const resetForm = () => {
    handleFilteredPayments([]);
    handleSelectedPayment(undefined);
  }

  const downloadTransactionProof = () => {
    const link = document.createElement("a");
    link.href = paymentTransactionProof;
    link.target = "_blank";
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
  }

  return isShown ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <div className="modal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={(e)=>{
                  resetForm();
                  close();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                
              
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Verify Payments</h2>
                    <div className="camp_right">
                      
                    </div>
                  </div>
                </div>

                <div className=" modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs">
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">

                          <div style={{marginBottom: "30px"}}>
                            <div className="print_btn" style={{float: "right"}}>
                              <button onClick={() => downloadTransactionProof()}>
                                Download Transaction Proof
                              </button>
                            </div>
                          </div>    

                          <div>
                            <label for="paymentid">Payments</label>
                            <select onChange={ (e)=> { handleSelectedPayment(e.target.value) }}>
                              <option>Select Payment</option>
                              { filteredPayments.length && filteredPayments.map( (payment, paymentKey) => (
                                <option value={ payment.id }> { payment.paymentId}</option>
                              ) )}
                            </select>
                          </div>

                          <div className="create_camp_btn" style={{width: "100%", marginTop: "50px"}}>
                           { selectedPayment!= undefined && (
                            <button style={{float: "right", padding: '10px', color: 'white'}} onClick={(e)=>{submitLinkedPayment(e)}}>Submit</button>
                           )} 
                            
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default VerifyReconciledPayment;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/VerifyReconciledPayment.js